import Vue from "vue";
import router from "../../../router";
import { mapActions, mapMutations, mapState } from "vuex";
import {
  SAVE_LOADING_STEP,
  TOGGLE_ADMIN_READY,
  TOGGLE_LOADING
} from "@/store/mutation-types";

export default {
  data() {
    return {
      readyTimer: null,
      readyTimerInterval: 1000,
      readyTimerCount: 0,
      
    };
  },
  computed: {
    ...mapState({
      adminReady: state => state.admin.adminReady,
      instanceReady: state => state.api.instanceReady,
      tokenAccess: state => state.auth.tokenAccess,
      passStatus: state => state.auth.passStatus
    })
  },
  watch: {
    instanceReady(value) {
      if (!value) {
        return;
      }

      this.SAVE_LOADING_STEP({ loading_step: "Loading" });

      this.loadProjects().then(() => {
        //this.loadPools().then(() => {
          this.loadUsers().then(() => {
            this.loadRealmSettings().then(() => {
              this.getNotifyStatus().then(() =>  {
                  this.SAVE_LOADING_STEP({ loading_step: null });
                  this.TOGGLE_LOADING({ loading: false });
                  this.TOGGLE_ADMIN_READY({ admin_ready: true });
                  this.validateRealmSettings().then((response) =>{
                  if(this.passStatus === 'no'){
                    router.push({'name': "UpdatePassword"}).catch(()=>{});
                  }
                });
              });
            });
          });
        //});
      });
    }
  },
  mounted() {
    if (this.adminReady) {
      return false;
    }

    if(Vue.prototype.$globalSettings.user_container_status === "Terminating"){
      this.TOGGLE_LOADING({ loading: true });
      this.SAVE_LOADING_STEP({ loading_step: "Terminating previous session, it may take a while" });
    }
    else{
      this.TOGGLE_LOADING({ loading: true });
      this.SAVE_LOADING_STEP({ loading_step: "Setting up your environment" });

      this.checkIfInstanceReady();
      this.readyTimer = setInterval(() => {
        this.checkIfInstanceReady();
      }, this.readyTimerInterval);
    }
  },
  methods: {
    ...mapActions(["loadProjects", "loadUsers", "loadPools", "checkInstance", "loadRealmSettings","getNotifyStatus","validateRealmSettings"]),
    ...mapMutations([SAVE_LOADING_STEP, TOGGLE_ADMIN_READY, TOGGLE_LOADING]),
    checkIfInstanceReady() {
      // Clear timer and logout if not fulfilled after 90 seconds
      // This error occurs when we're unable to connect the user with an instance
      // Can have several reasons: network interruptions, stopped server, instance didn't spin up or got terminated
      if (this.readyTimerCount * this.readyTimerInterval >= 120 * 1000) {
        clearInterval(this.readyTimer);

        // Stop executing ready call on local environment
        if (process.env.VUE_APP_ENVIRONMENT === "dev") {
          return;
        }

        // Inform user and logout
        alert("Unable to setup your environment");
        Vue.prototype.$authService.logout();
      }

      this.checkInstance().then(status => {
        this.readyTimerCount++;

        if (status === 200) {
          clearInterval(this.readyTimer);
          if (!window.__postLoginDeployCheckDone) {
            window.__postLoginDeployCheckDone = true;
            console.log("Checking application deployment version");
            this.checkAppDeployVersion();
        }
      }

        if (status === 403) {
          clearInterval(this.readyTimer);
          this.$toasted.show("API loading failed", { type: "error" });
        }
      });
    },
    confirmAppDeployVersionAndReload(deployDate) {
      const vu = new Vue()
      vu.$bvModal.msgBoxOk(
        "The application has been updated to a new version. Click OK to continue.",
        {
          title: "Application Updated",
          size: "md",
          okVariant: "primary",
          okTitle: "OK",
          hideHeaderClose: false,
          centered: true
        }
      ).then(() => {
          // User clicked OK
          console.log("First deployment version set");
          localStorage.setItem("appDeployDate", deployDate);
          window.location.replace(
          window.location.origin + window.location.pathname + '?v=' + new Date().getTime());
        }
      );
    },
    checkAppDeployVersion() {
      const CURRENT_DEPLOY_DATE = process.env.VUE_APP_DEPLOY_AT;
      const STORED_DEPLOY_DATE = localStorage.getItem("appDeployDate");
      /* Executed only on first deployment */
      if (STORED_DEPLOY_DATE === null) {
        this.confirmAppDeployVersionAndReload(CURRENT_DEPLOY_DATE);
        return false;
        
      }
      if (STORED_DEPLOY_DATE !== CURRENT_DEPLOY_DATE) {
          this.confirmAppDeployVersionAndReload(CURRENT_DEPLOY_DATE);
          return false;
      }
      const url = new URL(window.location.href);
      if (url.searchParams.has("v")) {
        url.searchParams.delete("v");
        window.history.replaceState({}, document.title, url.pathname); 
      }
      return true;
    },
    showRealmSettingsLimitMessage(){
      console.log("showRealmSettingsLimitMessage...")
      const vu = new Vue()
      vu.$bvModal.msgBoxOk(
        "Realm Limits Exceeded. You will be logged out from the application.",
        {
          title: "Warning! Realm Limits Exceeded.",
          size: "md",
          okVariant: "primary",
          okTitle: "OK",
          hideHeaderClose: false,
          centered: true
        }
      ).then(() => {
        Vue.prototype.$authService.logout();

        }
      );
    }
  }
};
